import {Component} from "@angular/core";
import {DxBaseModalComponent} from "../dx-base-modal.component";
import {SuiModal} from "ng2-semantic-ui";
import {DxModalResult} from "../../../domain/dx-modal-result";
import {DxModalContext} from "../../../domain/dx-modal-context";


@Component({
  selector: 'dx-error-modal',
  templateUrl: './dx-error-modal.component.html',
  styleUrls: ['./dx-error-modal.component.css']
})
export class DxErrorModalComponent extends DxBaseModalComponent {
  constructor(protected _modal: SuiModal<DxModalContext, DxModalResult, DxModalResult>) {
    super(_modal);
    this.message = this._modal.context.message;
  }
}
